module.exports = __webpack_public_path__ + "assets/img/7314ef90c2b5b38c7d89cc69b435e71c.svg";